/** Lightweight placeholder shown while the hero background/fonts are still loading. */
export default function HeroSkeleton() {
  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 px-6"
    >
      <div className="h-16 w-16 animate-pulse rounded-full bg-white/10" />
      <div className="h-6 w-64 animate-pulse rounded-full bg-white/10" />
      <div className="mt-2 h-10 w-full max-w-lg animate-pulse rounded-lg bg-white/10 sm:h-14" />
      <div className="h-10 w-4/5 max-w-md animate-pulse rounded-lg bg-white/10 sm:h-14" />
      <div className="mt-2 h-4 w-full max-w-md animate-pulse rounded bg-white/10" />
      <div className="h-4 w-2/3 max-w-sm animate-pulse rounded bg-white/10" />
      <div className="mt-6 flex gap-4">
        <div className="h-12 w-36 animate-pulse rounded-full bg-white/10" />
        <div className="h-12 w-36 animate-pulse rounded-full bg-white/10" />
      </div>
    </div>
  );
}
